type PassportCardUpdateTravellerDetailsType = NonNullable<App.PassportCardUpdateSnapshot['travellersDetailsV2']>[number]['type']

function toPassportCardUpdateTravellerDetailsType(
  travellerType: App.PassportCardTravellerType,
): PassportCardUpdateTravellerDetailsType {
  return travellerType === 'adult' ? 'adult' : 'children'
}

export function toPassportCardTravellersDetailsV2(
  travellers: Array<App.PassportCardInsuranceTraveller> | undefined,
): App.PassportCardUpdateSnapshot['travellersDetailsV2'] | undefined {
  if (!travellers?.length) return undefined
  if (travellers.some(traveller => !traveller.dateOfBirth)) return undefined

  return travellers.map(traveller => ({
    type: toPassportCardUpdateTravellerDetailsType(traveller.ageRange),
    date_of_birth: traveller.dateOfBirth,
  }))
}

export function getPassportCardUpdateCoverageAmount({
  existingOrderCoverageAmount,
  orderItemCoverAmount,
  priceDiff,
}: {
  existingOrderCoverageAmount: number
  orderItemCoverAmount?: number
  priceDiff: number
}): number {
  return (orderItemCoverAmount || existingOrderCoverageAmount) + priceDiff
}
